'use client';
import { useEffect } from 'react';
import useApiCall from '../../services/api/useApiCall';
import { endpoints } from '../../services/api/endpoints';
import { brandingConfig } from '@/config/branding';

export default function PilotRedirect() {
  const { makeApiCall } = useApiCall();

  useEffect(() => {
    const fetchConfigAndRedirect = async () => {
      try {
        const response = await makeApiCall(endpoints.getAppConfig);
        const targetUrl = response?.data?.pilotPortalUrl || brandingConfig.messages.pilotPortalUrl;
        window.location.href = targetUrl;
      } catch (error) {
        console.error('Redirect failed:', error);
        window.location.href = brandingConfig.messages.pilotPortalUrl;
      }
    };

    fetchConfigAndRedirect();
  }, [makeApiCall]);

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
        color: 'white',
        fontFamily: 'sans-serif',
      }}
    >
      <p>Redirecting to Pilot Portal...</p>
    </div>
  );
}
